module.exports = __webpack_public_path__ + "static/img/4.41af6077.png";